import Vue from 'vue'
import router from '@/router'
import { ACCESS_TOKEN } from "@/store/mutation-types";
import NProgress from 'nprogress' // progress bar
import { HomeLayout, LoginLayout, MenuLayout, CenterLayout } from './layouts'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

// no redirect whitelist
// const whiteList = ['/user/login', '/user/register', '/user/register-result','/user/alteration']
// need login list
const needLoginList = ['/center']

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  if (Vue.ls.get(ACCESS_TOKEN)) {
    /* has token */
    if (to.path === '/user/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      next()
    }
  } else {
    // if (whiteList.indexOf(to.path) !== -1) {
    //   // 在免登录白名单，直接进入
    //   next()
    // } else {
    //   next({ path: '/user/login', query: { redirect: to.fullPath } })
    //   NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    // }
    if (needLoginList.indexOf(to.path) !== -1) {
      next({ path: '/user/login', query: { redirect: to.fullPath } })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    } else {
      next()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})

/**
 * 基础路由
 * @type { *[] }
 */
const RouterMap = [
  {
    path: '/',
    name: 'home',
    redirect: '/home',
    component: HomeLayout,
    children: [
      {
        path: 'home',
        name: 'homeIndex',
        component: () => import(/* webpackChunkName: "default-home" */ './views/home/Home')
      }
    ]
  },
  {
    path: '/community',
    name: 'community',
    redirect: '/community/index',
    component: HomeLayout,
    children: [
      {
        path: 'index',
        name: 'communityIndex',
        component: () => import(/* webpackChunkName: "default-shequ" */ './views/community/Community')
      },
      {
        path: 'projectDetail',
        name: 'projectDetail',
        component: () => import(/* webpackChunkName: "default-shequ" */ './views/community/ProjectDetail')
      }
    ]
  },
  {
    path: '/course',
    name: 'course',
    redirect: '/course/index',
    component: HomeLayout,
    children: [
      {
        path: 'index',
        name: 'courseIndex',
        component: () => import(/* webpackChunkName: "default-mall" */ './views/course/CourseGoods')
      },
      {
        path: 'goodsDetail',
        name: 'goodsDetail',
        component: () => import(/* webpackChunkName: "default-mall" */ './views/course/CourseGoodsDetail')
      }
    ]
  },
  {
    path: '/contest',
    name: 'contest',
    redirect: '/contest/index',
    component: HomeLayout,
    children: [
      {
        path: 'index',
        name: 'contestIndex',
        component: () => import(/* webpackChunkName: "default-contest" */ './views/contest/Contest')
      }
    ]
  },
  {
    path: '/center',
    name: 'center',
    redirect: '/center/studentCenter',
    component: CenterLayout,
    children: [
      {//学生首页
        path: 'studentCenter',
        name: 'studentCenter',
        component: () => import(/* webpackChunkName: "default-center" */ './views/center/StudentCenter')
      },
      {//我的课程列表
        path: 'mineCourse',
        name: 'mingCourse',
        component: () => import(/* webpackChunkName: "default-center" */ './views/center/MineCourse')
      },
      {//课程单元地图
        path: 'mineUnitMap',
        name: 'mineUnitMap',
        component: () => import(/* webpackChunkName: "default-center" */ './views/center/MineUnitMap')
      },
      {//课程单元卡片
        path: 'mineUnitCard',
        name: 'mineUnitCard',
        component: () => import(/* webpackChunkName: "default-center" */ './views/center/MineUnitCard')
      },
      {//上课教室
        path: 'classroom',
        name: 'classroom',
        component: () => import(/* webpackChunkName: "default-center" */ './views/center/Classroom')
      }
    ]
  },
  {
    path: '/user',
    component: LoginLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "default-user" */ './views/user/Login')
      },
      {
        path: 'find',
        name: 'find',
        component: () => import(/* webpackChunkName: "default-user" */ './views/user/Alteration')
      },
      {
        path: 'register',
        name: 'register',
        component: () => import(/* webpackChunkName: "default-user" */ './views/user/Register')
      },
    ]
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "-default-fail" */ './views/exception/404')
  },

]
export default RouterMap